import { useState } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import {PanelBody,RangeControl} from '@wordpress/components';
import { VayuBlocksBorder,VayuBlocksDimensions,VayuBlocksBackground,VayuBlocksSize,ControlPanelControl } from '@vayu-blocks';
import { SlideButton } from '@vayu-blocks/global';

const Style = ({ attributes, setAttributes,clickBorderHover,openPanels, onTogglePanel }) => {

    const [hover, sethover] = useState('normal');

    const handelHover = (value) => {
        sethover(value);
        if (typeof clickBorderHover === 'function') {
            clickBorderHover(value);
        }
    }

    return (

        <>

            <PanelBody 
                title={__('Icon', 'vayu-blocks')} 
                opened={openPanels['overlay-icon']}
                onToggle={() => onTogglePanel('overlay-icon')} 
            >
                <VayuBlocksBackground
                     onChange={(key,value)=>setAttributes({[key]:value})}
                    colorPanel = {[
                        {
                            active: ['color'],
                            label: 'Icon Color',
                            key:'color',
                            value:attributes.color

                        },
                        {
                            active: ['color'],
                            label: 'Hover',
                            key:'hoverColor',
                            value:attributes.hoverColor
                        }
                    ]}
                />

                <VayuBlocksBackground
                    onChange={(key,value)=>setAttributes({[key]:value})}
                    colorPanel = {[
                        {
                            active: ['gradient'],
                            label: 'Background',
                            key:'backgroundcolor',
                            value:attributes.backgroundcolor
                        },
                        {
                            active: ['gradient'],
                            label: 'Hover',
                            key:'backgroundhoverColor',
                            value:attributes.backgroundhoverColor
                        }
                    ]}
                    headingLabel="Background"
                />

                <VayuBlocksSize
                    size={{key:'iconSize', value:attributes.iconSize}}
                    onChange={(key,value)=>setAttributes({[key]:value})}
                    label="Icon Size"
                />
                    
                <div className='vb-control-panel-size'>
                    <ControlPanelControl
                        label={ __( 'Stroke Settings', 'vayu-blocks' ) }
                        popoverClass = "vb-popover-stroke-width"
                    >

                        <VayuBlocksBackground
                            onChange={(key,value)=>setAttributes({[key]:value})}
                            colorPanel = {[
                                {
                                    active: ['color'],
                                    label: 'Icon',
                                    key:'stroke',
                                    value:attributes.stroke
                                }
                            ]}
                            headingLabel="Stroke"
                        />

                        <RangeControl
                            label={__('Stroke Width', 'vayu-blocks')}
                            max={1}
                            min={0}
                            step={.1}
                            __next40pxDefaultSize={true}
                            __nextHasNoMarginBottom={true}
                            marks
                            value={attributes.strokeWidth}
                            onChange={(value)=> setAttributes({strokeWidth:value})}
                        />

                        <RangeControl
                            label={__('Stroke Dash Size', 'vayu-blocks')}
                            max={10}
                            min={0}
                            __next40pxDefaultSize={true}
                            __nextHasNoMarginBottom={true}
                            marks
                            value={attributes.strokedashlength}
                            onChange={(value)=> setAttributes({strokedashlength:value})}
                        />

                        <RangeControl
                            label={__('Stroke Dash Gap', 'vayu-blocks')}
                            max={10}
                            min={0}
                            __next40pxDefaultSize={true}
                            __nextHasNoMarginBottom={true}
                            marks
                            value={attributes.strokedashgap}
                            onChange={(value)=> setAttributes({strokedashgap:value})}
                        />

                    </ControlPanelControl>
                </div>

            </PanelBody>

            <VayuBlocksDimensions  
                onChange={(key,value)=>setAttributes({[key]:value})}
                dimensions = {{
                    padding:{key:'iconpadding',value:attributes.iconpadding},
                }}
            />

            <PanelBody 
                title={ __( 'Border & Shadow', 'vayu-blocks' ) }
                opened={openPanels['overlay-border']}
                onToggle={() => onTogglePanel('overlay-border')} 
                className="th-button-panel"
            > 
                <SlideButton  
                    button={{ normal: "Normal", hover: "Hover" }}
                    onChange={(value)=>handelHover(value)}
                    defaultValue={'normal'}
                />    
                { 'normal' ===  hover &&  (	
                    <VayuBlocksBorder 
                        onChange={(key,value)=>setAttributes({[key]:value})}
                        border={{key:'iconsBorder',value:attributes.iconsBorder}}
                        borderRadius={{key:'iconsRadius',value:attributes.iconsRadius}}
                        dropShadow = {{key:'iconsDropShadow',value:attributes.iconsDropShadow}}
                    />
                ) || 'hover' ===  hover && (
                    <VayuBlocksBorder 
                        onChange={(key,value)=>setAttributes({[key]:value})}
                        border={{key:'iconsBorderHover',value:attributes.iconsBorderHover}}
                        borderRadius={{key:'iconsRadiusHover',value:attributes.iconsRadiusHover}}
                        dropShadow = {{key:'iconsDropShadowHover',value:attributes.iconsDropShadowHover}}
                    />
                )}
            </PanelBody>
        </>
    );
};

export default Style;